var g_devtricker_notification_page = 1;

document.addEventListener("DOMContentLoaded", async () => {

    let currentuserId = devtricker_getTheLoggedUserId();
    if (!currentuserId) {
        return;
    }

    const notificationBadge = document.getElementById("notificationBadge");
    const notificationCounter = document.getElementById("notificationCounter");
    const notificationsModalLabelCounter = document.getElementById("notificationsModalLabelCounter");
    const loadMoreNotificationsBtn = document.getElementById("loadMoreNotificationsBtn");

    const data = await devtricker_fetch_unread_notifications_count();

    if (data && data.has_unread) {
        fech_notifications_count(data);
    }

    // Increase the notificaiton interval using fib
    let fibCurrent = 1;
    let fibPrevious = 0;

    function scheduleNotificationCheck() {
        setTimeout(async function () {
            const data = await devtricker_fetch_unread_notifications_count();
            if (data && data.has_unread) {
                fech_notifications_count(data);
            }

            const next = fibCurrent + fibPrevious;
            fibPrevious = fibCurrent;
            fibCurrent = next;

            scheduleNotificationCheck();
        }, fibCurrent * 60000);
    }

    scheduleNotificationCheck();

    const markAllNotificationsAsRead = document.getElementById("markAllNotificationsAsRead");
    const notificationsContainer = document.getElementById("notifications-container");

    markAllNotificationsAsRead.addEventListener("click", async () => {
        markAllNotificationsAsRead.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> <span class="fw-semibold ms-1">Processing...</span>`;

        const result = await devtricker_ajax_mark_notifications_as_read();

        notificationBadge.classList.add("d-none");
        loadMoreNotificationsBtn.classList.add("d-none");
        notificationCounter.classList.add("d-none");
        notificationEmpty.classList.remove("d-none");
        notificationCounter.innerText = 0;
        notificationsModalLabelCounter.innerText = 0;
        notificationsContainer.innerHTML = "";
        markAllNotificationsAsRead.innerHTML = `<span class=" icon icon-check " ></span> Mark all as read</button>`;
        markAllNotificationsAsRead.classList.add("invisible");
    });

});

function fech_notifications_count(data) {

    const notificationBadge = document.getElementById("notificationBadge");
    const notificationCounter = document.getElementById("notificationCounter");
    const notificationsModalLabelCounter = document.getElementById("notificationsModalLabelCounter");

    notificationBadge.classList.remove("d-none");
    notificationCounter.classList.remove("d-none");
    notificationCounter.innerText = data.count;
    notificationsModalLabelCounter.innerText = data.count;
}

document.addEventListener("DOMContentLoaded", () => {

    let currentuserId = devtricker_getTheLoggedUserId();
    if (!currentuserId) {
        return;
    }
    
    let isLoading = false;
    let hasMore = true;

    const notificationsModal = document.getElementById('notificationsModal');
    const notificationsContainer = document.getElementById('notifications-container');
    const loadingIndicator = document.getElementById('loading-indicator');
    const notificationEmpty = document.getElementById("notificationEmpty");
    const notificationsModalLabelCounter = document.getElementById("notificationsModalLabelCounter");
    const markAllNotificationsAsRead = document.getElementById("markAllNotificationsAsRead");
    const loadMoreNotificationsBtn = document.getElementById("loadMoreNotificationsBtn");

    notificationsModal.addEventListener('shown.bs.modal', async () => {
        g_devtricker_notification_page = 1;
        hasMore = true;
        notificationsContainer.innerHTML = '';
        await loadNotifications(g_devtricker_notification_page);
        g_devtricker_notification_page = ++g_devtricker_notification_page;
    });


    loadMoreNotificationsBtn.addEventListener("click", async () => {
        await loadNotifications(g_devtricker_notification_page);
        g_devtricker_notification_page = ++g_devtricker_notification_page;
    });

    async function loadNotifications(page) {
        isLoading = true;
        loadingIndicator.style.display = 'block';
        notificationEmpty.classList.add("d-none");
        loadMoreNotificationsBtn.classList.add("d-none");

        const data = await devtricker_fetch_unread_notifications(page);

        if (data && devtricker_append_notifications(data)) {
            if (data.has_more) {
                hasMore = true;
                loadMoreNotificationsBtn.classList.remove("d-none");
            } else {
                loadMoreNotificationsBtn.classList.add("d-none");
            }
        } else {
            console.log("No more notifications to load.");
            hasMore = false;
            loadMoreNotificationsBtn.classList.add("d-none");
        }

        if (data.total_items_count <= 0) {
            notificationEmpty.classList.remove("d-none");
            markAllNotificationsAsRead.classList.add("invisible");
            notificationsModalLabelCounter.innerText = "0";
            notificationBadge.classList.add("d-none");
            notificationCounter.innerText = "0";
            notificationCounter.classList.add("d-none");
        } else {
            notificationEmpty.classList.add("d-none");
            markAllNotificationsAsRead.classList.remove("invisible");
            notificationBadge.classList.remove("d-none");
            notificationCounter.classList.remove("d-none");
            notificationCounter.innerText = data.total_items_count;
            notificationsModalLabelCounter.innerText = data.total_items_count;
        }

        loadingIndicator.style.display = 'none';
        isLoading = false;
    }
});

function devtricker_append_notifications(data) {
    const container = document.getElementById("notifications-container");
    if (!data || data.html === "") {
        console.log('No new data provided for appending notifications.');
        return false;
    }

    container.innerHTML += data.html;

    const timeElements = container.querySelectorAll("[data-created-at]");
    timeElements.forEach(element => {
        const utcDateString = element.getAttribute('data-created-at');
        const timeDiff = devtricker_human_getTimeDiff(utcDateString);
        element.textContent = timeDiff;
    });

    return true;
}